import React from "react";
import Banner from "./banner";

function Banners(props) {
  return (
    <div className="card-deck mb-3 text-center">
      {props.banners.map(c => <Banner id={c.id} key={c.id} title={c.title} footer={c.footer} items={c.items}  promoNA={props.promoNA} />)}
    </div>
  );
}

export default Banners;